import { Immutable } from '@zervant/reactcomponents'

import { ExternalAccountInterface } from '../Interfaces/ExternalAccountInterface'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = null

type StateType = ExternalAccountInterface[] | null
type PayloadType = ExternalAccountInterface[]

// eslint-disable-next-line no-underscore-dangle
function _getExternalAccounts(state: StateType, payload: PayloadType): StateType {
  return Immutable.copy(payload)
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('GET_EXTERNAL_ACCOUNTS', _getExternalAccounts)
  .build()

export default reducer
